import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { Modal } from "./Brands";

const empty = { name: "", email: "", role: "viewer", password: "" };

export default function UsersPage() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/users").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (modal === "new") {
      await api.post("/users", form);
    } else {
      const patch = { name: form.name, role: form.role, status: form.status };
      if (form.password) patch.password = form.password;
      await api.patch(`/users/${modal}`, patch);
    }
    setModal(null); load();
  };

  return (
    <Layout title="Admin Users" subtitle="Access"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => { setForm(empty); setModal("new"); }} data-testid="add-user-btn"><Plus size={14} /> New user</button>}>
      <div className="card-sharp">
        <table className="fin">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Last login</th><th></th></tr></thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.id}`}>
                <td className="font-medium">{u.name}</td>
                <td className="text-[#595959]">{u.email}</td>
                <td><span className="badge badge-gold">{u.role.replace("_"," ")}</span></td>
                <td><span className={`badge badge-${u.status}`}>{u.status}</span></td>
                <td className="text-[#8C8C8C] text-[12px]">{u.last_login ? new Date(u.last_login).toLocaleString() : "—"}</td>
                <td className="text-right">
                  <button className="btn-outline mr-2" style={{padding:"6px 10px"}} onClick={() => { setForm({ ...u, password: "" }); setModal(u.id); }}><Edit2 size={12} /></button>
                  <button className="btn-outline" style={{padding:"6px 10px"}} onClick={async () => { if (confirm("Delete user?")) { await api.delete(`/users/${u.id}`); load(); } }}><Trash2 size={12} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal onClose={() => setModal(null)} title={modal === "new" ? "New admin user" : "Edit user"}>
          <form onSubmit={save} className="space-y-4">
            <div><div className="label-tiny mb-1.5">Name</div><input className="fin" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="user-name" /></div>
            {modal === "new" && (
              <div><div className="label-tiny mb-1.5">Email</div><input type="email" className="fin" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} data-testid="user-email" /></div>
            )}
            <div><div className="label-tiny mb-1.5">Role</div>
              <select className="fin" value={form.role} onChange={(e) => setForm({...form, role: e.target.value})} data-testid="user-role">
                <option value="super_admin">Super Admin</option>
                <option value="manager">Manager</option>
                <option value="viewer">Viewer</option>
              </select>
            </div>
            {modal !== "new" && (
              <div><div className="label-tiny mb-1.5">Status</div>
                <select className="fin" value={form.status || "active"} onChange={(e) => setForm({...form, status: e.target.value})}>
                  <option value="active">Active</option><option value="inactive">Inactive</option>
                </select>
              </div>
            )}
            <div><div className="label-tiny mb-1.5">{modal === "new" ? "Password" : "New password (leave empty to keep)"}</div>
              <input type="password" className="fin" required={modal === "new"} value={form.password||""} onChange={(e) => setForm({...form, password: e.target.value})} data-testid="user-password" />
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="save-user-btn">Save</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
